export const lightColors = {};

export const darkColors = {};

export default {
  paper: "#ffffff",

  // primary
  primaryLight: "#e3f2fd",
  primary200: "#ffffff",
  primaryMain: "#8672FF",
  primaryDark: "#8672FF",
  primary800: "#1565c0",

  // secondary
  secondaryLight: "#ffffff",
  secondary200: "#b39ddb",
  secondaryMain: "#5669dc",
  secondary800: "#4527a0",

  secondary: "#5669dc",

  // success
  successLight: "#b9f6ca",
  successMain: "#00e676",
  successDark: "#54c081",

  // error
  errorLight: "#ef9a9a",
  errorMain: "#f44336",

  // orange
  orangeLight: "#fbe9e7",
  orangeMain: "#ffab91",
  orangeDark: "#d84315",

  // warning
  warningLight: "#F2994A",
  warningMain: "#ffe57f",
  warningDark: "#ffc107",

  danger: "#D3625B",

  warning: "#B79C4A",

  // grey
  grey50: "#fafafa",
  grey100: "#f5f5f5",
  grey200: "#eeeeee",
  grey300: "#e0e0e0",
  grey500: "#9e9e9e",
  grey600: "#757575",
  grey700: "#616161",
  grey900: "#212121",

  // -----------------------|| DARK THEME VARIANTS ||-----------------------//

  // paper & background
  darkPaper: "#1a223f",
  darkBackground: "#1a223f",

  // dark 800 & 900
  darkLevel1: "#111936",
  darkLevel2: "#1a223f",
  darkLevel3: "#212946",
  darkLevel4: "#29314f",
  darkLevel5: "#273051",
  wallet: "#1B223F",

  // text variants
  darkTextPrimary: "#ffffff",
  darkTextSecondary: "#8492c4",
  darkTextTertiary: "#4F5A84",
  darkTextFourth: "#29314F",
  darkTextFifth: "#212946",

  disable: "#4F5A84",

  lightPrimaryMain: "#8672FF",

  lightTextTitle: "#212121",
  lightTextPrimary: "#212121",
  lightTextSecondary: "#757575",
  lightTextTertiary: "#9E9E9E",
  lightTextFourth: "#F5F5F5",
  lightTextFifth: "#FAFAFA",

  lightLevel2: "#EFEFFF",
  lightLevel4: "#FAFAFA",
  lightLevel5: "#FAFAFA",

  lightGray200: "#f5f5f5",
  lightGray50: "#fafafa",

  lightGray200BorderColor: "#EFEFFF",

  // primary dark
  darkPrimaryLight: "#e3f2fd",
  darkPrimaryMain: "#8672FF",
  darkPrimaryDark: "#5669dc",
  darkPrimary200: "#000001",
  darkPrimary800: "#1565c0",
  dark400: "#4F5A84",

  // secondary dark
  darkSecondaryLight: "#212946",
  darkSecondaryMain: "#5669dc",
  darkSecondaryDark: "#5669dc",
  darkSecondary200: "#b39ddb",
  darkSecondary800: "#6200ea",

  defaultGradientStart: "#5569db",
  defaultGradientEnd: "#8572ff",
  border0: "#4F5A84",
  border1: "#353C5D",

  apr: "#54C081",
  success: "#54C081",
  "text.success": "#54C081",
  color0: "#313A5A",
};
